import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";
import deleteAccount from "../../../../app/integrations/settings/sso-google/glist/actions/delete-account";

// const debug = "GoogleModule"
const debug = false

export class SSOGoogleModule extends ModuleProto {

    public googleAccounts : any[]
    public googleLogins   : any[]
    public googleCalendars: any[]

    constructor() {
        super(ModuleType.SSO_GOOGLE, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                       = "Login With Google"
        this.description                = "The Login with Google module enables users to quickly sign in using their Google account, streamlining access and enhancing security."
        this.svgIcon                    = "isvg-google-auth-integration"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.settingsUrl                = "settings/integrations/google"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.googleAccounts             = []
        this.googleLogins               = []
        this.googleCalendars            = []

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    disable = async ()=> {
        _.map(this.googleLogins, (login: any)=>{
            gd.api.MyAccount.unlinkGoogleAccount(login.googleUserId)
        })
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
